import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const categories = [
  { value: 'general', label: 'Geral', icon: 'ri-question-line' },
  { value: 'whatsapp', label: 'WhatsApp / Conexão', icon: 'ri-whatsapp-line' },
  { value: 'campaigns', label: 'Campanhas', icon: 'ri-megaphone-line' },
  { value: 'templates', label: 'Templates', icon: 'ri-file-text-line' },
  { value: 'contacts', label: 'Contatos', icon: 'ri-contacts-book-line' },
  { value: 'billing', label: 'Financeiro / Planos', icon: 'ri-bank-card-line' },
  { value: 'integrations', label: 'Integrações', icon: 'ri-plug-line' },
  { value: 'reports', label: 'Relatórios', icon: 'ri-bar-chart-box-line' },
  { value: 'settings', label: 'Configurações', icon: 'ri-settings-3-line' },
];

const priorities = [
  { value: 'low', label: 'Baixa', desc: 'Dúvida geral, sem urgência' },
  { value: 'medium', label: 'Média', desc: 'Problema afetando uso parcial' },
  { value: 'high', label: 'Alta', desc: 'Funcionalidade importante com problema' },
  { value: 'urgent', label: 'Urgente', desc: 'Sistema indisponível ou campanha parada' },
];

export default function SupportNewTicketPage() {
  const navigate = useNavigate();
  const [subject, setSubject] = useState('');
  const [category, setCategory] = useState('general');
  const [priority, setPriority] = useState('medium');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!subject.trim() || !message.trim()) return;
    // In real app, call API
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="max-w-lg mx-auto py-16 text-center">
        <div className="w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-500/10 flex items-center justify-center mx-auto mb-5">
          <i className="ri-check-line text-2xl text-emerald-600 dark:text-emerald-400" />
        </div>
        <h2 className="text-xl font-heading font-bold text-foreground-950 dark:text-foreground-100 mb-2">Chamado aberto com sucesso!</h2>
        <p className="text-sm text-foreground-500 mb-6">Nossa equipe responderá em até 4 horas úteis. Você receberá uma notificação quando houver resposta.</p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate('/support')}
            className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Ver Meus Chamados
          </button>
          <button
            onClick={() => { setSubmitted(false); setSubject(''); setMessage(''); }}
            className="px-5 py-2.5 bg-background-100 dark:bg-background-200 hover:bg-background-200 dark:hover:bg-background-300 text-foreground-700 dark:text-foreground-300 text-sm font-medium rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            Abrir Outro
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/support')}
          className="inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-foreground-700 dark:hover:text-foreground-300 transition-colors mb-4 cursor-pointer"
        >
          <i className="ri-arrow-left-line" /> Voltar
        </button>
        <h2 className="text-xl font-heading font-bold text-foreground-950 dark:text-foreground-100">Abrir Chamado</h2>
        <p className="text-sm text-foreground-500 mt-1">Descreva seu problema ou dúvida e nossa equipe responderá o mais rápido possível.</p>
      </div>

      {/* Form */}
      <div className="bg-white dark:bg-background-100 rounded-2xl border border-background-200 dark:border-background-300 p-6 space-y-5">
        {/* Subject */}
        <div>
          <label className="block text-sm font-medium text-foreground-700 dark:text-foreground-300 mb-1.5">Assunto</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Ex: Erro ao enviar campanha programada"
            maxLength={150}
            className="w-full bg-background-50 dark:bg-background-200 border border-background-200 dark:border-background-300 rounded-xl px-4 py-2.5 text-sm text-foreground-900 dark:text-foreground-100 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-4 focus:ring-primary-100/50"
          />
        </div>

        {/* Category */}
        <div>
          <label className="block text-sm font-medium text-foreground-700 dark:text-foreground-300 mb-2">Categoria</label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {categories.map((cat) => (
              <button
                key={cat.value}
                onClick={() => setCategory(cat.value)}
                className={`flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  category === cat.value
                    ? 'bg-primary-50 dark:bg-primary-500/10 text-primary-700 dark:text-primary-400 border border-primary-200 dark:border-primary-500/20'
                    : 'bg-background-50 dark:bg-background-200 text-foreground-600 dark:text-foreground-400 border border-transparent hover:border-background-300 dark:hover:border-background-400'
                }`}
              >
                <i className={cat.icon} />
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Priority */}
        <div>
          <label className="block text-sm font-medium text-foreground-700 dark:text-foreground-300 mb-2">Prioridade</label>
          <div className="space-y-2">
            {priorities.map((p) => (
              <button
                key={p.value}
                onClick={() => setPriority(p.value)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all cursor-pointer ${
                  priority === p.value
                    ? 'bg-primary-50 dark:bg-primary-500/10 border border-primary-200 dark:border-primary-500/20'
                    : 'bg-background-50 dark:bg-background-200 border border-transparent hover:border-background-300 dark:hover:border-background-400'
                }`}
              >
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  priority === p.value ? 'border-primary-500' : 'border-background-300 dark:border-background-400'
                }`}>
                  {priority === p.value && <div className="w-2.5 h-2.5 rounded-full bg-primary-500" />}
                </div>
                <div>
                  <span className="text-sm font-semibold text-foreground-800 dark:text-foreground-200 block">{p.label}</span>
                  <span className="text-[11px] text-foreground-500">{p.desc}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Message */}
        <div>
          <label className="block text-sm font-medium text-foreground-700 dark:text-foreground-300 mb-1.5">Descrição</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Descreva seu problema com o máximo de detalhes possível. Inclua prints, mensagens de erro, passos para reproduzir o problema..."
            maxLength={2000}
            rows={5}
            className="w-full bg-background-50 dark:bg-background-200 border border-background-200 dark:border-background-300 rounded-xl p-4 text-sm text-foreground-900 dark:text-foreground-100 placeholder:text-foreground-400 resize-none focus:border-primary-400 focus:ring-4 focus:ring-primary-100/50 outline-none"
          />
          <span className="text-[10px] text-foreground-400 mt-1 block">{message.length}/2000</span>
        </div>

        {/* Submit */}
        <div className="flex items-center gap-3 pt-2">
          <button
            onClick={handleSubmit}
            disabled={!subject.trim() || !message.trim()}
            className="flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 disabled:bg-background-200 disabled:text-foreground-400 text-white text-sm font-semibold rounded-xl transition-all duration-200 shadow-sm hover:shadow-md active:scale-[0.98] cursor-pointer whitespace-nowrap disabled:cursor-not-allowed"
          >
            <i className="ri-send-plane-fill" /> Enviar Chamado
          </button>
          <button
            onClick={() => navigate('/support')}
            className="px-5 py-2.5 text-sm font-medium text-foreground-600 dark:text-foreground-400 hover:bg-background-100 dark:hover:bg-background-200 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}